import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadTestDataSuccessAction, testDataActionTypes} from '../actions/test-data';

export interface TestDataState {
  array: number[];
}

const initialState: TestDataState = {
  array: [0]
};

export function testDataReducer(state: TestDataState = initialState, action: Action): TestDataState {
  switch (action.type) {
    case testDataActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case testDataActionTypes.UPDATE:
      return handleUpdateSuccessAction(state, action);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: TestDataState, action: LoadTestDataSuccessAction): TestDataState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleUpdateSuccessAction(state: TestDataState, action: LoadTestDataSuccessAction): TestDataState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

export const testDataSelectors = {
  array: (state: TestDataState) => _.get(state, 'array', [])
};
